module.exports = __webpack_public_path__ + "static/move-bottom-banner-to-top-on-category-page-e0890c539e4d67da987a4b6724d5c4a8.png";